import { SHAPES } from 'atoms/TrackIcon/TrackIcon';

import { ICareerSkillCluster } from 'core/hooks/CareerSkillGraph/transform/transformCareerSkillGraph';

/**
 * Знак группы навыков на карте (ТЗ 0070).
 *
 * 🔴 Поле `GrowthTrackSkillCluster.icon` доезжает до фронта, но в базе оно
 * ПУСТОЕ почти везде: сид заводит группы только кодом, названием и порядком, а
 * синтетические группы-категории и вовсе отдают пустую строку. Рендер, который
 * верит одному этому полю, не показал бы ничего. Поэтому здесь тот же приём с
 * тремя уровнями, что у `SkillIcon`: выбор человека → значение по умолчанию →
 * нейтральный знак.
 *
 * 🔴 Значение по умолчанию берётся по КОДУ группы, а не по «преобладающей
 * категории её навыков». Категория — функция состава: добавили в группу один
 * навык — и картинка сменилась, хотя группа осталась той же. Код стабилен, и
 * свойство «одинаковые данные дают одинаковую картинку» держится по
 * построению, как и вся остальная раскладка.
 *
 * ⚠️ Это словарь ОТКАТА, а не классификатор. Незнакомый код обязан получить
 * нейтральный знак группы, а не догадку: список кодов пополняет методист, и
 * угаданный не туда значок хуже честного «просто группа».
 */

/** Нейтральный знак: группа, для которой ничего лучше не известно. */
export const FALLBACK_CLUSTER_ICON = 'group';

/**
 * Коды, которые реально порождают сид карты (`seed_track_skill_graph`) и
 * синтетические группы по категориям навыка (`services/skill_graph`).
 */
const CLUSTER_ICON_BY_CODE: Record<string, string> = {
  // python-backend
  language: 'code',
  backend: 'server',
  data: 'database',
  ops: 'infinity',
  // devops
  linux: 'server',
  containers: 'cloud',
  cloud: 'cloud',
  automation: 'infinity',
  observability: 'chart',
  lang: 'code',
  // data-science
  analysis: 'chart',
  models: 'cpu',
  delivery: 'rocket',
  // cybersecurity
  foundation: 'server',
  network: 'shield',
  offence: 'shield',
  infra: 'server',
  // frontend
  framework: 'browser',
  tools: 'check',
  // синтетические группы по категории навыка
  library: 'code',
  tool: 'check',
  database: 'database',
  domain: 'chart',
  soft: 'group',
};

export const resolveClusterIcon = (cluster: Pick<ICareerSkillCluster, 'code' | 'icon'>): string => {
  if (cluster.icon && SHAPES[cluster.icon]) return cluster.icon;
  const byCode = CLUSTER_ICON_BY_CODE[cluster.code];
  if (byCode && SHAPES[byCode]) return byCode;
  return FALLBACK_CLUSTER_ICON;
};
